export default __webpack_public_path__ + "static/media/Map.6cc2a048.svg";